<!-- <div class="col-6 asessmentList">
  <form [formGroup]="assessmentForm">
    <label class="ques">
      <span *ngIf="!isArabic">Please select an Assessment :</span>
      <span *ngIf="isArabic">: يرجى تحديد التقييم</span>
    </label>
    <div class="ans-pnl">
      <select class="form-select" (change)="selectQuestionnaire($event)" formControlName="questionnaire"
        [ngClass]="isArabic ? 'rightAlign' : ''">
        <option value=""><span *ngIf="!isArabic">Select Option</span><span *ngIf="isArabic">اختر خياراً</span>
        </option>
        <option *ngFor="let eachQuestionnaire of questionnaireList; let i=index;"
          [value]="eachQuestionnaire.questionnaireId">{{eachQuestionnaire.questionnaireName}}</option>
      </select>
    </div>
  </form>
</div>  -->
<div class="row" [ngClass]="isArabic ? 'arabicAlign' : ''">
  <div class="col-8 asessmentList">
    <form [formGroup]="assessmentForm">
      <label class="ques p-0" [ngClass]="isArabic ? 'rightAlign' : ''">
        <span *ngIf="!isArabic">Please select an Assessment :</span>
        <span *ngIf="isArabic">: يرجى اختيار تقييم</span>
      </label>
      <div class="ans-pnl">
        <select class="form-select" (change)="selectQuestionnaire($event)" formControlName="questionnaire"
          [ngClass]="isArabic ? 'rightAlign' : ''">
          <option value=""><span *ngIf="!isArabic">Select Option</span><span *ngIf="isArabic">اختر خياراً</span>
          </option>
          <option *ngFor="let eachQuestionnaire of questionnaireList; let i=index;"
            [value]="eachQuestionnaire.questionnaireId">{{eachQuestionnaire.questionnaireName}}</option>
        </select>
      </div>
    </form>
  </div>
  <div class="col-6">
  </div>
</div>